Vue.component("checkout-page", () => import("./CheckoutPage"));
